import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-sms(1)",
  "use": "icon-icon-sms(1)-usage",
  "viewBox": "0 0 35.986 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35.986 36\" id=\"icon-icon-sms(1)\">\r\n  <path id=\"icon-icon-sms(1)_icon-sms\" d=\"M18.738,0C8.417,0,.026,7.2.026,16.08A15.629,15.629,0,0,0,5.783,28.8V34.08c0,1.439.48,1.92,1.2,1.92a1.837,1.837,0,0,0,1.2-.48l5.758-3.361a32.513,32.513,0,0,0,4.8.482c10.319,0,17.273-7.679,17.273-16.553S27.385,0,18.738,0Zm0,30.239c-.961,0-3.359-.239-4.318-.239l-.959-.239-.72.48-4.318,2.4V27.6l-.959-.72a13.83,13.83,0,0,1-4.8-10.8c0-7.679,7.2-13.675,16.319-13.675,6.96,0,14.88,5.758,14.88,13.675-.239,8.153-6.719,14.153-15.125,14.153ZM9.625,14.16a2.159,2.159,0,1,0,1.528.633A2.184,2.184,0,0,0,9.625,14.16Zm8.4,0a2.159,2.159,0,1,0,1.528.633,2.184,2.184,0,0,0-1.533-.633Zm8.4,0a2.159,2.159,0,1,0,1.528.633,2.184,2.184,0,0,0-1.526-.633Z\" transform=\"translate(-0.026)\" fill=\"#fff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-sms(1).svg
// module id = qdyZ
// module chunks = 5